import axios from 'axios';
import { UtenteLoginCommand, UtenteLoginModel, Utente, UtenteList, IdVersion, UtenteCreateCommand, UtenteUpdateCommand, UtenteChangePasswordCommand, UtenteResetPasswordCommand, IdDisplayName } from '../types';
import { utilityService } from './common/utility-service';

const baseUrl = '/api/v1/utenti';

export const getByKey = async (id: number): Promise<Utente> => {
    return (await axios.get(`${baseUrl}/${id}`)).data;
};

export const login = async (command: UtenteLoginCommand): Promise<UtenteLoginModel> => {
    return (await axios.post(`${baseUrl}/login`, command)).data;
};

export const getList = async (): Promise<UtenteList[]> => {
    return (await axios.get(`${baseUrl}`)).data;
};

export const create = async (command: UtenteCreateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/create`, command)).data;
};

export const update = async (command: UtenteUpdateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/update`, command)).data;
};

export const changePassword = async (command: UtenteChangePasswordCommand): Promise<void> => {
    return (await axios.post(`${baseUrl}/change-password`, command)).data;
};

export const resetPassword = async (command: UtenteResetPasswordCommand): Promise<void> => {
    return (await axios.post(`${baseUrl}/reset-password`, command)).data;
};

export const remove = async (items: IdVersion[]): Promise<void> => {
    return (await axios.delete(`${baseUrl}/remove?${utilityService.toQueryStringMultiple(items)}`)).data;
};

export const getAllTipi = async (): Promise<IdDisplayName[]> => {
    return (await axios.get(`${baseUrl}/tipi`)).data;
};
